import { COMPANY_CARD_CLICKED, SORTING_RULES } from "./constants";

const amplitudeData = {
	selectedLabelsArr: {
		cities: [],
		industry: [],
		type: [],
	},
};
amplitudeData.isAutomaticOpen = true;

const amplitudeState = new Proxy(amplitudeData, {
	get: (data, prop) => getAmplitudeData(data, prop),
	set: (data, prop, value) => setAmplitudeData(data, prop, value),
});

function getAmplitudeData(data, prop) {
	try {
		if (prop === "allTargetData") return data;

		return data[prop];
	} catch (e) {
		console.error(e);
	}
}

function setAmplitudeData(data, prop, value) {
	try {
		data[prop] = value;

		const commonData = prepareSharedData(data);

		if (prop === "formAction" && value === COMPANY_CARD_CLICKED) {
			whenCompanyCardClicked(data, commonData);
		}

		if (prop !== "isRequestReady") {
			return true;
		}

		delete commonData.items_page_num;

		window.wp_amplitude.event("wp_search_results_load", {
			...commonData,
			action: data.formAction,
		});

		return true;
	} catch (e) {
		console.error(e);
	}
}

/**
 * Generate form action handle name for facets options
 * @param name - name of the input field
 * @param action - action made using the react-select
 *
 * @Component - ReactSelect.Service.jsx
 *
 * @returns - strings like filter_location_apply,etc
 */
function amplitudeCheckboxesActionString({ name, checked }) {
	try {
		const initialPrefix = "filter_";

		let inputFieldName;
		switch (name) {
			case "industry":
				inputFieldName = "industry_";
				break;

			case "cities":
				inputFieldName = "location_";
				break;

			case "type":
				inputFieldName = "jobtype_";
				break;

			default:
				break;
		}

		let actionType;
		switch (checked) {
			case true:
				actionType = "apply";
				break;

			default:
				actionType = "discard";
				break;
		}

		return initialPrefix.concat(inputFieldName, actionType);
	} catch (e) {
		console.error(e);
	}
}

/**
 * Prepare the common data that would be used across multiple features the AMP team requested
 * @param {Object} data
 * @returns Object
 */
function prepareSharedData(data) {
	try {
		const {
			formData: { keywordSearch: search, sortingRule: sorting } = {},
			selectedLabelsArr: {
				cities: filter_location,
				industry: filter_industry,
				type: filter_jobtype,
			} = {},
			totalResults: results = 0,
			totalPages: items_pages_list_length = 0,
			currentPage: items_page_num = 0,
		} = data;

		const prepareAmpData = {
			url: window.location.href,
			page_name: "Unternehmen Archive",
			page_type: "companies",
			location: "faceted_search",
			search: search?.length > 0 ? search : "null",
			results: updateObjectNumber(results) ? results : 0,
			items_pages_list_length: updateObjectNumber(items_pages_list_length)
				? items_pages_list_length
				: 0,
			items_page_num: updateObjectNumber(items_page_num) ? items_page_num : 0,
			filter_industry: returnNullIfArrayEmpty(filter_industry),
			filter_jobtype: returnNullIfArrayEmpty(filter_jobtype),
			filter_location: returnNullIfArrayEmpty(filter_location),
			sorting: checkSortingLabel(sorting),
		};

		return prepareAmpData;
	} catch (e) {
		console.error(e);
	}
}

/**
 * Triggers when company card is clicked
 * @param {Object} data
 * @param {Object} commonData
 *
 * @function setAmplitudeData - proxy setter
 */
function whenCompanyCardClicked(data, commonData) {
	try {
		let prepareAmpData = { ...commonData };

		prepareAmpData = appendClickedCompanyInformation(prepareAmpData, data);

		window.wp_amplitude.event("wp_search_results_click", { ...prepareAmpData });
	} catch (e) {
		console.error(e);
	}
}

/**
 * Append the clicked company card information along with shared data
 * @param {*} filteredData
 * @param {*} fullData
 *
 * @function whenCompanyCardClicked
 * @returns
 */
function appendClickedCompanyInformation(filteredData, fullData) {
	try {
		const {
			clickedCompanyData: {
				index: item_num,
				jobs: open_positions,
				title: company_name,
				link: item_url,
			} = {},
		} = fullData;

		return {
			...filteredData,
			item_num: increaseNumByOneCount(item_num),
			item_url,
			company_name: company_name.replace(/<[^>]*>/g, ""),
			open_positions,
		};
	} catch (e) {
		console.error(e);
	}
}

const updateObjectNumber = (num) => {
	if (!isNaN(num) && num > 0) return true;
};

const increaseNumByOneCount = (num) => {
	if (!isNaN(num)) {
		return num + 1;
	}
};

const checkSortingLabel = (sortKey) => {
	switch (sortKey) {
		case SORTING_RULES.ASC_ALPHA:
			return "alphabet_asc";
			break;
		case SORTING_RULES.DESC_ALPHA:
			return "alphabet_desc";
			break;
		case SORTING_RULES.NEWEST:
			return "newest_added";
			break;
		default:
			return "recommended";
	}
};

const returnNullIfArrayEmpty = (arr) => (arr?.length > 0 ? arr : "null");

/**
 * Trigger when facets are checked or unchecked
 * @param { boolen } checked - True if checked, else false
 * @param { string } label - Label of the checkbox un/checked
 * @param { string } slug - Field type ( could be industry, type or location )
 */
function setAmplitudeFacetData(checked, label, slug) {
	if (checked) {
		amplitudeState.selectedLabelsArr[slug] = [...new Set(
			[
				...amplitudeState.selectedLabelsArr[slug],
				label,
			]
		)];
	} else {
		amplitudeState.selectedLabelsArr[slug] = [...new Set(
			[
				...amplitudeState.selectedLabelsArr[slug].filter(
					(item) => item !== label,
				),
			]
		)];
	}
}

export {
	amplitudeState,
	amplitudeCheckboxesActionString,
	setAmplitudeFacetData,
};
